import { ActionType } from '../actions/actionTypes'
import { ContractAction } from '../actions/contractActions'
import initialState, { ContractsState } from '../reducers/initialState'
export default function contractReducer(
  state = initialState.contracts as ContractsState,
  action: ContractAction
): ContractsState {
  switch (action.type) {
    case ActionType.LOAD_CUSTOMER_STATS_SUCCESS:
      return {
        ...state,
        stats: action.stats,
      }
    default:
      return state
  }
}
